import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GuestSessionState {
  token: string | null;
  expiresAt: string | null;
}

const initialState: GuestSessionState = {
  token: null,
  expiresAt: null,
};

const guestSessionSlice = createSlice({
  name: 'guestSession',
  initialState,
  reducers: {
    setGuestSession: (state, action: PayloadAction<{ token: string; expiresAt: string }>) => {
      state.token = action.payload.token;
      state.expiresAt = action.payload.expiresAt;
    },
    clearGuestSession: (state) => {
      state.token = null;
      state.expiresAt = null;
    },
  },
});

export const { setGuestSession, clearGuestSession } = guestSessionSlice.actions;
export const selectGuestToken = (state: { guestSession: GuestSessionState }) => state.guestSession.token;
export const selectGuestExpiresAt = (state: { guestSession: GuestSessionState }) => state.guestSession.expiresAt;
export default guestSessionSlice.reducer;
